export default __webpack_public_path__ + "static/media/heightMap.5c44a4bd.webp";